<template>
    <div class="videoplay">
        <navbar :title="text_title"></navbar>
        <video 
         autoplay 
            :src= this.course_listb.course_url
            controls  name="media"  class="videoSize">
        </video>
        
    </div>
</template>
<script>
import Vue from 'vue';
import { Loading } from 'vant';

Vue.use(Loading);
import navbar from '../../components/Navbar'
    //视频
    // import Video from 'video.js'
    // import 'video.js/dist/video-js.css'
    // Vue.prototype.$video = Video
    import '@/assets/classmatter.css'
    export default {
        components:{
            navbar
        },
        data(){
            return{
                text_title:'视频播放',
                liveDetail: {},
                liveLocation:'',
                course_listb:[],
                userInfo: {},
                Cida:'',
                coursetype:'',
                cidb:'',
                isshow:true
            }
        },
        mounted() { 
            this.getParams();
        },
        methods:{
            icon () {
                this.$router.go(-1)
            },
            getParams() {
                var that=this
                // 接收传过来的课程信息
                //this.liveDetail = JSON.parse(this.$route.query.liveDetail);
                this.Cida = this.$route.query.xlcid;//系列
                this.Cid = this.$route.query.Cid;//课程
                // this.Type = this.$route.query.Type
                this.Token = this.$route.query.Token
                // this.Token = 'e10b82bc219d3c328e0e4c89890fe286'
                this.coursetype = this.$route.query.coursetype
                //判断课程  1：系列   2：单独课程
                console.log(this.Cida)
                if( this.coursetype == 1 ){
                    this.cidb = this.Cida
                    console.log(this.cidb)
                }else if( this.coursetype == 2 ){
                    console.log("2222222222")
                    this.cidb = this.Cid
                    console.log(this.cidb)
                   
                }
                this.$http.post('/live/course/index',
                    {  
                        cid: this.cidb,
                        token: this.Token
                    },{
                        emulateJSON:true
                    }
                )
                .then(list => { 
                    this.course_listb = list.data.result; 
                    that.isshow=false
                    console.log(this.course_listb)  
                })
                .catch(error => {
                    console.log("error.response")
                })
            }


        },
    }

</script>
<style scoped>
.jiazai{
    margin-top: 100px;
    text-align: center;
}
.videoSize{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/playback/playback.vue